import { computed, defineComponent, nextTick, ref, watch } from "vue";
import { useStore } from "vuex";
import { collect as collectApi, del as delApi, share as shareApi, submitTask } from "@/service/canvas";
import { ElMessage, ElMessageBox } from "element-plus";
import settingBar from "@/components/AiCanvas/setting-bar";
import sliderBar from "@/components/AiCanvas/slider-bar";
import imgCropping from "@/components/ImgCropping";
import dayjs from "dayjs";
import { ACTION_TYPE, TASK_STATUS, UPSCALE_TYPES, VARIATION_TYPES } from "@/common/constant";
import { default as _copyToClipboard } from "copy-to-clipboard";
import usePrompt from "@/hooks/usePrompt";
import useTask from "@/hooks/useTask";
import useHistory from "@/hooks/useHistory";
import AiUploadImg from "@/components/AiUploadImg";
export default defineComponent({
  name: "ai-canvas",
  components: {
    sliderBar,
    settingBar,
    imgCropping,
    AiUploadImg
  },
  setup() {
    // 绘画历史记录
    const {
      history,
      loading: historyLoading,
      finish: historyFinish,
      active: historyActive,
      getHistory
    } = useHistory();
    // 任务
    useTask(history);
    const store = useStore();
    const historyBar = ref(null);

    // 处理Prompt，用户的输入、图片，提示词
    const {
      promptParams,
      submitPrompt,
      beautifyText,
      cleanText,
      writing,
      beautifulLoading
    } = usePrompt();
    if (store.state.drawSame) {
      promptParams.text = store.state.drawSame;
      // 清空
      store.commit("SET_DRAW_SAME", "");
    }
    const img_urls = computed(() => {
      return store.state.drawUploadImgs;
    });
    watch(historyActive, () => {
      isIc.value = false;
    });
    let taskLoading = ref(false);
    // 当前任务
    const currentTask = computed(() => {
      return history.value[historyActive.value] || {};
    });
    // 当前选中任务绘画进度
    const drawProgress = computed(() => {
      return currentTask.value.jindu || "准备中...";
    });
    // 当前选中任务是否在绘画中
    const drawLoading = computed(() => {
      return currentTask.value.code === TASK_STATUS.CREATED || currentTask.value.code === TASK_STATUS.READY;
    });

    // 文本输入框
    const textarea = ref(null);

    // 分享 删除 收藏loading
    const shareLoading = ref(false);
    const delLoading = ref(false);
    const collectLoading = ref(false);

    // 图片裁剪
    const ic = ref(null);
    const isIc = ref(false);

    /**
     * 发送任务
     * @param action
     * @param index
     */
    const send = async (action, index) => {
      if (taskLoading.value) return ElMessage.warning("当前还有任务在执行哦");
      try {
        taskLoading.value = true;
        // 先提交任务
        const res = await submitTask({
          action: action,
          prompt: action === ACTION_TYPE.IMAGINE ? submitPrompt.value : "",
          taskId: action === ACTION_TYPE.IMAGINE ? "" : currentTask.value.renwu_id,
          index: index,
          base64: store.state.drawUploadImgs.join(" ")
        });
        const {
          errno
        } = res;
        if (errno === 0) {
          cleanText();
          await getHistory(1);
          await nextTick();
          historyBar.value.scrollToOrigin();
        }
      } catch (e) {
        console.log(e);
      }
      taskLoading.value = false;
    };

    /**
     * 制到剪切板
     * @param text
     */
    function copyToClipboard(text) {
      _copyToClipboard(text);
      ElMessage.success("已复制到剪切板");
    }

    /**
     * 分享
     * @param id
     */
    function share(id) {
      shareLoading.value = true;
      shareApi(id).then(res => {
        if (!res.errno) {
          ElMessage.success(res.message);
        }
      }).finally(() => {
        shareLoading.value = false;
      });
    }

    /**
     * 删除
     * @param id
     */
    function del(id) {
      ElMessageBox.confirm("确认删除该作品吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        delLoading.value = true;
        delApi(id).then(res => {
          if (!res.errno) {
            history.value = history.value.filter(item => {
              return item.renwu_id !== id;
            });
            historyActive.value = 0;
          }
          ElMessage.success(res.message);
        }).finally(() => {
          delLoading.value = false;
        });
      }).catch(() => {});
    }

    /**
     * 收藏
     * @param id
     */
    function collect(id) {
      collectLoading.value = true;
      collectApi(id).then(res => {
        if (!res.errno) {
          ElMessage.success(res.message);
        }
      }).finally(() => {
        collectLoading.value = false;
      });
    }

    /**
     * 优化关键词
     */
    function beautifulWords() {
      beautifyText(() => {
        textarea.value.textarea.scrollTo(0, 999999);
      });
    }

    /**
     * 裁剪
     * @returns {Promise<void>}
     */
    async function crop() {
      isIc.value = true;
      await nextTick();
      ic.value.split();
    }
    getHistory();
    return {
      historyBar,
      ic,
      isIc,
      writing,
      history,
      img_urls,
      historyFinish,
      promptParams,
      submitPrompt,
      currentTask,
      historyActive,
      historyLoading,
      beautifulLoading,
      drawProgress,
      drawLoading,
      textarea,
      shareLoading,
      delLoading,
      taskLoading,
      collectLoading,
      UPSCALE_TYPES,
      VARIATION_TYPES,
      ACTION_TYPE,
      send,
      share,
      del,
      crop,
      dayjs,
      collect,
      getHistory,
      beautifulWords,
      copyToClipboard
    };
  }
});